import { Component } from '@angular/core';
import { DelSketch, SetSketchIndex } from '../../training.actions';
import { sketchIndex } from '../../training.selectors';
import { CareComponent } from '../care.component';
import { OverviewComponent } from '../overview/overview.component';

@Component({
  selector: 'sketches',
  templateUrl: './sketches.component.html',
  styleUrls: ['./sketches.component.scss']
})
export class SketchesComponent extends OverviewComponent {
  sketches: any[] = []
  sketch_number: number = 0 //used by the editor
  sketch_time: number = 0
  last_sketch_at: number = 0
  bHasSelectedSketch: boolean = false

  async setInScene(_bUserSelectedCamera: boolean, _from: string) {
    if (this.act) {
      setTimeout(() => this.loadTaskSketches())

    }

  }
  ngAfterViewInit() { //We only listen to ...

    console.log('sketches')
    super.ngAfterViewInit()
    this.subscriptions.push(this.trainingStore.select(sketchIndex).subscribe((index: number) => {
      this.changeSketch(index)
    }))

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  loadTaskSketches() {
    this.bHasSelectedSketch = false
    // this.trainingStore.dispatch(new SetSketchIndex(-1))

    let rv = this.getCurrentTaskAndScene()
    let task: any = rv.task

    if (task) {
      if (task.sketches) {
        this.sketches = task.sketches
        if (this.sketches.length > 0) {
          this.sketch_number = 0
          return
        }
      }

      this.sketches = []
      this.sketch_number = 0
    }
  }

  changeSketch($event: any) {
    if (this.sketches && this.sketches.length > 0) {
      this.sketch_number = $event + 1
      let sketch = this.sketches[this.sketch_number - 1]
      if (sketch) {
        this.sketch_time = sketch.time
      }
    }

  }
  delSketch() {
    this.trainingStore.dispatch(new DelSketch(this.sketch_number - 1))
    this.training_service.delSketch(this.sketch_number - 1)
  }
  prev() {
    if (this.sketches && this.sketches.length > 0) {
      if (!this.bHasSelectedSketch) {
        this.sketch_number = 1
        this.bHasSelectedSketch = true
        this.trainingStore.dispatch(new SetSketchIndex(0))
      } else {
        if (this.sketch_number > 1) {
          this.sketch_number--
          this.trainingStore.dispatch(new SetSketchIndex(this.sketch_number - 1))
        }
      }
    }
  }
  next() {
    if (this.sketches && this.sketches.length > 0) {
      if (!this.bHasSelectedSketch) {
        this.sketch_number = 1
        this.bHasSelectedSketch = true
        this.trainingStore.dispatch(new SetSketchIndex(0))
      } else {
        if (this.sketch_number < this.sketches.length) {
          this.trainingStore.dispatch(new SetSketchIndex(this.sketch_number))
        }
      }
    }
  }
  click() {
    this.trainingStore.dispatch(new SetSketchIndex(this.sketch_number - 1))
  }
}
